import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    // Check if user is logged in from sessionStorage
    const storedAuth = sessionStorage.getItem('adminAuth');
    if (storedAuth) {
      const parsed = JSON.parse(storedAuth);
      setIsAuthenticated(true);
      setCredentials(parsed);
    }
  }, []);

  const login = (username, password) => {
    const creds = { username, password };
    setCredentials(creds);
    setIsAuthenticated(true);
    sessionStorage.setItem('adminAuth', JSON.stringify(creds));
  };

  const logout = () => {
    setCredentials(null);
    setIsAuthenticated(false);
    sessionStorage.removeItem('adminAuth');
  };

  const getAuthHeader = () => {
    if (credentials) {
      const encoded = btoa(`${credentials.username}:${credentials.password}`);
      return `Basic ${encoded}`;
    }
    return null;
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, getAuthHeader, credentials }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
